import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { postLogin } from "../APIs/api-routes.util";
import { LoginResponse } from "../APIs/api.types";
import logo from "../Assets/logo.png";
import { Alert } from "../components/ui/Alert";
import { Button } from "../components/ui/Button";
import { Input } from "../components/ui/Input";
import { LoadingOverlay } from "../components/ui/PagePrimitives";

function Login() {
  const [errorMessage, setErrorMessage] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setErrorMessage("");
    postLogin({ password }).subscribe({
      next: (res) => {
        setLoading(false);
        const body = res.response as LoginResponse;
        if (body?.status === "200") {
          localStorage.setItem("user_info", JSON.stringify(body));
          navigate("/dashboard");
        } else {
          setErrorMessage("Incorrect password. Please try again.");
        }
      },
      error: () => {
        setLoading(false);
        setErrorMessage("Could not reach the server. Verify XAMPP is running.");
      },
    });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-app-shell px-4 py-8">
      <LoadingOverlay show={loading} />
      <div className="w-full max-w-app overflow-hidden rounded-2xl bg-surface shadow-phone">
        <div className="bg-header-bar px-6 py-8 text-center text-white">
          <div className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/20 p-2">
            <img src={logo} alt="Naveed Tazeen Clinic" className="h-full w-full rounded-xl object-contain" />
          </div>
          <h1 className="text-xl font-semibold">Naveed Tazeen Clinic</h1>
          <p className="mt-1 text-sm text-white/80">Appointment admin panel</p>
        </div>

        <div className="p-6">
          <h2 className="mb-1 text-center text-base font-semibold text-brand-800">Sign in</h2>
          <p className="mb-5 text-center text-sm text-content-muted">Enter your password to continue</p>

          {errorMessage && (
            <Alert variant="error" className="mb-4">
              {errorMessage}
            </Alert>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Password"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              disabled={loading}
            />
            <Button type="submit" fullWidth size="lg" disabled={loading || !password}>
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
